import { ElementRef } from '@angular/core';
import { DATA_EXPORT_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { SecuritiesService } from '../../services/securities.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import { formatDateString } from 'NewAngular/utils/date';
import { downloadUrl } from 'NewAngular/utils/download';
import * as i0 from "@angular/core";
import * as i1 from "../../services/securities.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/date-controls/date-range/date-range.component";
import * as i5 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = (a0, a1) => ({ startDate: a0, endDate: a1 });
const _c1 = a0 => ({ disabled: a0 });
function HistoricalDataTableComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13);
    i0.ɵɵtext(2, "Loading Data...");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 14);
    i0.ɵɵelementEnd();
} }
/*
 *
 * Historical Data Table Component
 *
 * Required Attributes:
 *      @ calcName : 'price', 'level', etc.
 *      @ securityId : `security_id` for the given security
 *      @ securityType : 'company', `'index', 'indicator', 'mutual_fund', 'model_portfolio'
 *
 * Optional Attributes:
 *      @ startDate : specify the startDate via 'MM/DD/YYYY'
 *      @ endDate   : specify the endDate via 'MM/DD/YYYY'
 *
 */
export class HistoricalDataTableComponent {
    constructor(securitiesService, featureService, eltRef) {
        this.securitiesService = securitiesService;
        this.featureService = featureService;
        this.eltRef = eltRef;
        this.pageNum = 1;
        this.dataTableHtml = '';
        this.totalPageNum = 1;
        this.loading = false;
        this.selectedDateRange = { startDate: null, endDate: null };
        const DEFAULT_START_YEAR = 1890;
        const startDate = eltRef.nativeElement.getAttribute('startDate');
        const endDate = eltRef.nativeElement.getAttribute('endDate');
        // use `endDate` if provided, or default to today's date.
        this.endDate = endDate ? new Date(endDate) : new Date();
        // use `startDate` if provided, or default to Jan 1st, 1890.
        this.startDate = new Date(startDate || `01/01/${DEFAULT_START_YEAR}`);
        this.securityId = eltRef.nativeElement.getAttribute('securityId');
        this.securityType = eltRef.nativeElement.getAttribute('securityType');
        this.calcName = eltRef.nativeElement.getAttribute('calcName');
        this.currentYear = new Date().getFullYear();
        this.selectedDateRange = { startDate: this.startDate, endDate: this.endDate };
    }
    ngOnInit() {
        this.loading = true;
        this.getHistoricalData();
    }
    getIsLast() {
        return this.pageNum >= this.totalPageNum;
    }
    getIsFirst() {
        return this.pageNum === 1;
    }
    changeDateSelection(newDateRangeObj) {
        if (newDateRangeObj.startDate) {
            this.selectedDateRange.startDate = newDateRangeObj.startDate;
        }
        if (newDateRangeObj.endDate) {
            this.selectedDateRange.endDate = newDateRangeObj.endDate;
        }
        this.getHistoricalData();
    }
    firstPageHandler() {
        // skip if the component is disabled.
        if (this.getIsFirst())
            return;
        this.pageNum = 1;
        this.getHistoricalData();
    }
    nextPageHandler() {
        // skip if the component is disabled.
        if (this.getIsLast())
            return;
        this.pageNum = Math.min(this.pageNum + 1, this.totalPageNum);
        this.getHistoricalData();
    }
    previousPageHandler() {
        // skip if the component is disabled.
        if (this.getIsFirst())
            return;
        this.pageNum = Math.max(this.pageNum - 1, 1);
        this.getHistoricalData();
    }
    lastPageHandler() {
        // skip if the component is disabled.
        if (this.getIsLast())
            return;
        this.pageNum = this.totalPageNum;
        this.getHistoricalData();
    }
    getHistoricalData() {
        const getParams = {
            // We should have non-null values for these variable. Only possibly null at declaration
            startDate: formatDateString(this.selectedDateRange.startDate),
            endDate: formatDateString(this.selectedDateRange.endDate),
            pageNum: this.pageNum,
        };
        const urlParams = { calcName: this.calcName, securityId: this.securityId };
        this.securitiesService.getSecurityDataTable(this.securityType, urlParams, getParams).subscribe({
            next: (rsp) => {
                this.dataTableHtml = rsp.data_table_html;
                this.totalPageNum = rsp.last_page_num;
            },
            error: () => { },
            complete: () => {
                this.loading = false;
            },
        });
    }
    exportHistoricalData() {
        if (!this.featureService.userHasFeatures([DATA_EXPORT_FEATURE])) {
            this.featureNeededComponent.openModal(DATA_EXPORT_FEATURE);
            return;
        }
        const urlParams = {
            calcName: this.calcName,
            securityId: this.securityId,
            // need to pass an explicit `locales` argument to `toLocaleDateString`
            // or this will break for users with non-US language/region settings
            startDate: this.selectedDateRange.startDate.toLocaleDateString('en-US'),
            endDate: this.selectedDateRange.endDate.toLocaleDateString('en-US'),
        };
        const url = this.securitiesService.getSecurityDataTableExportUrl(this.securityType, urlParams);
        downloadUrl(url);
    }
}
HistoricalDataTableComponent.ɵfac = function HistoricalDataTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HistoricalDataTableComponent)(i0.ɵɵdirectiveInject(i1.SecuritiesService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
HistoricalDataTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HistoricalDataTableComponent, selectors: [["ycn-historical-data-table"]], viewQuery: function HistoricalDataTableComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { calcName: "calcName", securityId: "securityId", securityType: "securityType", startDate: "startDate", endDate: "endDate" }, standalone: false, decls: 28, vars: 27, consts: [[1, "form-inline", "chart-options"], [1, "data-range-cover", "form-inline", "input-group"], [1, "form-label"], [1, "inputs-wrap", 3, "startDateChangeHandler", "endDateChangeHandler", "startYear", "endYear", "selectedDateRange"], [1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "panel-pagination", "chart-options"], [1, "panel-pagination-content"], [1, "panel-pagination-count"], [1, "divider-vertical"], ["class", "loader", 4, "ngIf"], [3, "innerHTML"], [1, "loader"], [1, "loader-message"], [1, "loader-spinner"]], template: function HistoricalDataTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        i0.ɵɵtext(3, "Date Range");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "ycn-date-range", 3);
        i0.ɵɵlistener("startDateChangeHandler", function HistoricalDataTableComponent_Template_ycn_date_range_startDateChangeHandler_4_listener($event) { return ctx.changeDateSelection($event); })("endDateChangeHandler", function HistoricalDataTableComponent_Template_ycn_date_range_endDateChangeHandler_4_listener($event) { return ctx.changeDateSelection($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵlistener("click", function HistoricalDataTableComponent_Template_div_click_5_listener() { return ctx.exportHistoricalData(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(6, "svg", 5);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(7, "span");
        i0.ɵɵtext(8, "Export");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(9, "div", 6)(10, "div", 7)(11, "div", 8);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(13, "div", 9);
        i0.ɵɵelementStart(14, "div", 4);
        i0.ɵɵlistener("click", function HistoricalDataTableComponent_Template_div_click_14_listener() { return ctx.firstPageHandler(); });
        i0.ɵɵtext(15, "First");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(16, "div", 9);
        i0.ɵɵelementStart(17, "div", 4);
        i0.ɵɵlistener("click", function HistoricalDataTableComponent_Template_div_click_17_listener() { return ctx.previousPageHandler(); });
        i0.ɵɵtext(18, "Prev");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "div", 9);
        i0.ɵɵelementStart(20, "div", 4);
        i0.ɵɵlistener("click", function HistoricalDataTableComponent_Template_div_click_20_listener() { return ctx.nextPageHandler(); });
        i0.ɵɵtext(21, "Next");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(22, "div", 9);
        i0.ɵɵelementStart(23, "div", 4);
        i0.ɵɵlistener("click", function HistoricalDataTableComponent_Template_div_click_23_listener() { return ctx.lastPageHandler(); });
        i0.ɵɵtext(24, "Last");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(25, HistoricalDataTableComponent_div_25_Template, 4, 0, "div", 10);
        i0.ɵɵelement(26, "div", 11)(27, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("startYear", 1890)("endYear", ctx.currentYear)("selectedDateRange", i0.ɵɵpureFunction2(16, _c0, ctx.startDate ?? null, ctx.endDate ?? null));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-export");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate2(" Viewing ", ctx.pageNum, " of ", ctx.totalPageNum, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(19, _c1, ctx.getIsFirst()));
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(21, _c1, ctx.getIsFirst()));
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(23, _c1, ctx.getIsLast()));
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(25, _c1, ctx.getIsLast()));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("innerHTML", ctx.dataTableHtml, i0.ɵɵsanitizeHtml);
    } }, dependencies: [i3.NgIf, i4.DateRangeComponent, i5.FeatureNeededComponent, i6.IconDirective], encapsulation: 2 });
